import * as React from 'react';
import {
	PremiumReportData,
	withPremiumReportContext,
} from '../../context/premiumReport';
import { BodyContainer, LayoutContainer, TopContainer } from '../common';
import LargeCenterSpinner from '../LargeCenterSpinner';
import Breadcrumbs from '../premiumReports/Breadcrumbs';
import Overview from '../premiumReports/Overview';
import PremiumReportActions from '../premiumReports/PremiumReportActions';

interface Props {
	children?: JSX.Element | JSX.Element[];
	premiumReportData: PremiumReportData;
}

const PremiumReportLayout = (props: Props) => {
	const [loading, setLoading] = React.useState<boolean>(false);
	props.premiumReportData.setLoading = setLoading;

	const renderActions = () => {
		return <PremiumReportActions />;
	};

	return (
		<>
			{loading ? <LargeCenterSpinner /> : null}
			<TopContainer>
				<Breadcrumbs />
				{renderActions()}
			</TopContainer>
			<LayoutContainer>
				<BodyContainer>
					<Overview />
					{props.children}
				</BodyContainer>
			</LayoutContainer>
		</>
	);
};

export default withPremiumReportContext<Props>(PremiumReportLayout);
